var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.999,
    height: 22.75,
    viewBox: "0 0 25.999 22.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#74c6cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009fe3"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M-17.875-1.625h-3.25A1.625,1.625,0,0,1-22.75-3.25v-13a1.625,1.625,0,0,1,1.625-1.625h3.25A1.625,1.625,0,0,0-16.25-19.5a1.624,1.624,0,0,0-1.625-1.625h-3.25A4.875,4.875,0,0,0-26-16.25v13a4.875,4.875,0,0,0,4.875,4.875h3.25A1.625,1.625,0,0,0-16.25,0,1.624,1.624,0,0,0-17.875-1.625ZM-.477-10.9l-6.5-6.5a1.624,1.624,0,0,0-2.3,0,1.624,1.624,0,0,0,0,2.3l3.73,3.725h-10.7A1.623,1.623,0,0,0-17.875-9.75,1.624,1.624,0,0,0-16.25-8.125h10.7L-9.272-4.4a1.624,1.624,0,0,0,0,2.3,1.624,1.624,0,0,0,2.3,0l6.5-6.5A1.626,1.626,0,0,0-.477-10.9Z",
    transform: "translate(26 21.125)",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignout);
export default __webpack_public_path__ + "static/media/signout.b436ce7b07cdcc1effd0d102ee860f8d.svg";
export { ForwardRef as ReactComponent };